// 银行的类型
export const bankType = ['Bank Transfer', 'Bank']

// 印尼银行的列表
export const bankIndonesiaList = [
  { text: 'BankBCA', value: 'bca' },
  { text: 'Bank BRI', value: 'bri' },
  { text: 'BANK CIMB NIAGA', value: 'cimb' },
  { text: 'BANK DANAMON INDONESIA', value: 'danamon' },
  { text: 'BANK MEGA', value: 'mega' },
  { text: 'BANK OCBC NISP', value: 'ocbc' },
  { text: 'BANK MANDIRI', value: 'mandiri' },
  { text: 'BANK BNI 46', value: 'bni' },
  { text: 'Bank Tabungan Pensiunan Nasional', value: 'btpn' },
  { text: 'BSI (Bank Syariah Indonesia)', value: 'bsi' },
  { text: 'BANK PERMATA', value: 'permata' },
  { text: 'BANK PANIN', value: 'panin' },
  { text: 'BANK MAYBANK INDONESIA', value: 'maybank' },
  { text: 'HSBC', value: 'hsbc' },
  { text: 'CITIBANK', value: 'citibank' },
  { text: 'ARTOS', value: 'artos' }
]

// 摩洛哥银行的列表（MA）
export const bankIndonesiaListMA = [
  { text: 'Attijariwafa Bank', value: 'Attijariwafa Bank' },
  { text: 'Banque Populaire (BCP)', value: 'Banque Populaire (BCP)' },
  { text: 'BMCE Bank of Africa', value: 'BMCE Bank of Africa' },
  { text: 'Société Générale Maroc', value: 'Société Générale Maroc' },
  { text: 'Crédit du Maroc', value: 'Crédit du Maroc' },
  { text: 'CIH Bank', value: 'CIH Bank' },
  {
    text: 'Banque Centrale Populaire (BCP)',
    value: 'Banque Centrale Populaire (BCP)'
  },
  { text: 'Crédit Agricole du Maroc', value: 'Crédit Agricole du Maroc' },
  { text: 'Al Barid Bank', value: 'Al Barid Bank' },
  {
    text: "BMCI (Banque Marocaine pour le Commerce et l'Industrie)",
    value: "BMCI (Banque Marocaine pour le Commerce et l'Industrie)"
  },
  {
    text: 'آخر',
    value: 'آخر'
  }
]

// 哥伦比亚的列表 1
export const columbiaList1 = [
  { text: 'Cédula de Identidad', value: '00' },
  { text: 'Cédula de Identidad de Extranjero', value: '01' }
]

// 哥伦比亚的列表 2
export const columbiaList2 = [
  { text: 'Cuenta Corriente', value: '00' },
  { text: 'Cuenta de Ahorros', value: '01' }
]
